import { api } from '../api.js';
import { esc, money, dateTime, dateOnly, statusBadge, toast, guard } from '../ui.js';

export async function guestsView(root) {
  root.innerHTML = `
    <div class="page-head"><h1>Guests</h1></div>
    <form class="toolbar" id="search" role="search">
      <label class="field" style="flex:1 1 320px"><span>Search by name or email</span><input type="search" name="q" autocomplete="off"></label>
      <button class="btn small" type="submit">Search</button>
    </form>
    <div class="split">
      <div id="list" style="flex:999 1 520px"></div>
      <div id="detail" style="flex:1 1 360px"></div>
    </div>`;

  const load = guard(async (q = '') => {
    const { contacts } = await api(`/contacts?search=${encodeURIComponent(q)}`);
    root.querySelector('#list').innerHTML = contacts.length ? `<div class="table-wrap"><table class="data">
      <thead><tr><th>Guest</th><th>Bookings</th><th>Lifetime</th><th>Tags</th><th>Since</th></tr></thead>
      <tbody>${contacts.map((c) => `<tr class="clickable" data-id="${c.id}" tabindex="0">
        <td><strong>${esc([c.first_name, c.last_name].filter(Boolean).join(' ') || c.email)}</strong><div class="small muted">${esc(c.email)}</div></td>
        <td>${c.bookings}</td><td>${money(c.lifetime_cents)}</td>
        <td>${(c.tags || []).map((t) => `<span class="badge">${esc(t)}</span>`).join(' ')}</td>
        <td class="small">${esc(dateOnly(c.created_at))}</td></tr>`).join('')}</tbody></table></div>`
      : '<p class="notice">No guests found.</p>';
  });

  const open = guard(async (id) => {
    const { contact: c, bookings, rsvps, emails } = await api(`/contacts/${id}`);
    const d = root.querySelector('#detail');
    d.innerHTML = `<form class="box" id="contact-form" data-id="${c.id}">
      <h2>${esc([c.first_name, c.last_name].filter(Boolean).join(' ') || c.email)}</h2>
      <p class="small"><a href="mailto:${esc(c.email)}">${esc(c.email)}</a>${c.phone ? ` · <a href="tel:${esc(c.phone)}">${esc(c.phone)}</a>` : ''}
        ${c.sms_opt_in ? '<br><span class="muted">Opted in to texts</span>' : ''}</p>
      <label class="field"><span>Tags (comma separated)</span><input name="tags" value="${esc((c.tags || []).join(', '))}" placeholder="VIP, Repeat, Corporate"></label>
      <label class="field"><span>Staff notes</span><textarea name="notes" rows="4" placeholder="Allergies, preferences, occasions">${esc(c.notes || '')}</textarea></label>
      <div><button class="btn small primary" type="submit">Save</button></div>
      <h2>Bookings</h2>
      ${bookings.length ? bookings.map((b) => `<div class="summary-row"><span>${esc(dateTime(b.starts_at))} · ${esc(b.experience)} · ${b.guest_count}</span>${statusBadge(b.status)}</div>`).join('') : '<p class="small muted">None yet.</p>'}
      <h2>RSVPs</h2>
      ${rsvps.length ? rsvps.map((r) => `<div class="small">${esc(dateOnly(r.created_at))} · ${esc(r.event_name || 'RSVP')} · ${r.guest_count} guest(s)${r.message ? `<div class="muted">"${esc(r.message)}"</div>` : ''}</div>`).join('') : '<p class="small muted">None.</p>'}
      <h2>Emails sent</h2>
      ${emails.length ? emails.map((m) => `<div class="small">${esc(dateTime(m.created_at))} · ${esc(m.template_key.replace(/_/g, ' '))}${m.status !== 'sent' ? ' <span class="badge red">failed</span>' : ''}</div>`).join('') : '<p class="small muted">None.</p>'}
    </form>`;
    d.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  root.querySelector('#search').addEventListener('submit', (e) => { e.preventDefault(); load(new FormData(e.target).get('q')); });
  root.querySelector('#list').addEventListener('click', (e) => { const tr = e.target.closest('tr[data-id]'); if (tr) open(tr.dataset.id); });
  root.querySelector('#list').addEventListener('keydown', (e) => { const tr = e.target.closest('tr[data-id]'); if (tr && e.key === 'Enter') open(tr.dataset.id); });
  root.querySelector('#detail').addEventListener('submit', guard(async (e) => {
    e.preventDefault();
    const f = new FormData(e.target);
    const tags = String(f.get('tags') || '').split(',').map((t) => t.trim()).filter(Boolean);
    await api(`/contacts/${e.target.dataset.id}`, { method: 'PUT', body: { notes: f.get('notes'), tags } });
    toast('Guest saved');
    load(new FormData(root.querySelector('#search')).get('q') || '');
  }));
  load();
}
